import { RouterView } from 'vue-router';
import type { RouteRecordRaw } from 'vue-router';
export const routes: RouteRecordRaw[] = [
  {
    path: 'cco-panel',
    component: RouterView,
    meta: {
      layoutFeatures: {
        actionPanel: true,
      },
    },
    children: [
      {
        path: '',
        component: () => import('@/app/modules/cco-panel/views/cco-panel-index.vue'),
        redirect: '/cco-panel/global-performance',
        children: [
          {
            path: 'global-performance',
            component: () =>
              import('@/app/modules/cco-panel/views/cco-panel-global-performance.vue'),
          },
          {
            path: 'performance-local',
            component: () =>
              import('@/app/modules/cco-panel/views/cco-panel-performance-local.vue'),
          },
          {
            path: 'shortage',
            component: () => import('@/app/modules/cco-panel/views/cco-panel-shortage.vue'),
          },
          {
            path: 'sellthrough',
            component: () => import('@/app/modules/cco-panel/views/cco-panel-sellthrough.vue'),
          },
          {
            path: 'out-of-shelf',
            component: () => import('@/app/modules/cco-panel/views/cco-panel-out-of-shelf.vue'),
          },
        ],
      },
    ],
  },
];
export default routes;
